module.exports = __webpack_public_path__ + "img/IMG_7001.bf25d689.webp";